import { FiSearch } from "react-icons/fi";
import { T } from "../../constants/theme";

export default function EmptyState({ onReset }) {
  return (
    <div
      style={{
        textAlign: "center",
        padding: "70px 20px",
        background: T.white,
        border: `1px solid ${T.border}`,
        borderRadius: 16,
      }}
    >
      <div
        style={{
          width: 64,
          height: 64,
          borderRadius: "50%",
          background: T.goldLight,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          margin: "0 auto 18px",
        }}
      >
        <FiSearch size={26} color={T.gold} />
      </div>
      <h3 style={{ margin: "0 0 8px", fontSize: 20, color: T.ink }}>No Products Found</h3>
      <p style={{ margin: "0 0 22px", color: T.muted, fontSize: 14 }}>
        Try changing your search or filters.
      </p>
      <button
        onClick={onReset}
        style={{
          padding: "12px 26px",
          fontSize: 12,
          fontWeight: 700,
          letterSpacing: ".1em",
          textTransform: "uppercase",
          border: "none",
          borderRadius: 999,
          background: T.ink,
          color: T.white,
          cursor: "pointer",
        }}
      >
        Reset Filters
      </button>
    </div>
  );
}
